import { SortDirectionCapital } from '../../../types'
import { getInitialPaginationDataFromKeys } from '../../../utils'
import { PlannedTradeColumnKey, TradingPlanInitialState } from '../types'

export const plannedTradeColumns: PlannedTradeColumnKey[] = [
  'symbol',
  'plannedDate',
  'direction',
  'entryPrice',
  'stopLoss',
  'takeProfit',
  'positionSize',
  // 'contractSize',
  'riskPercent',
  'riskRewardRatio',
  'tradeTriggerDate',
  'tradeCloseDate',
  'outcome',
  'pnl',
  'deviated',
]

const initialState: TradingPlanInitialState = {
  plannedTrades: [],
  pagination: {
    ...getInitialPaginationDataFromKeys<PlannedTradeColumnKey>(plannedTradeColumns),
    order: SortDirectionCapital.desc,
    orderBy: 'plannedDate',
  },
  loading: false,
  saving: false,
  deleting: false,
  reports: null,
  reportsLoading: false,
  reportsError: null,
}

export type TradingPlanState = TradingPlanInitialState

export default initialState
